<script setup>
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';
import { useRoute, useRouter } from 'vue-router';
import { onMounted, ref } from 'vue';
import ConfirmDeleteInfoModal from './components/ConfirmDeleteInfoModal.vue';
import SuccessDeleteInfoModal from './components/SuccessDeleteInfoModal.vue';
import LoadingScreen from './components/LoadingScreen.vue';
import SuccessEditInfoModal from './components/SuccessEditInfoModal.vue';
import { useSubscriberStore } from './stores/subscriber';
import { useAdminStore } from '@/stores/admin'; 
const route = useRoute();
const router = useRouter();


const showDeleteInfoModal = ref(false);
const toggleDeleteInfoModal = (show) => {

  showDeleteInfoModal.value = show;
}



import { deleteSubscription } from '@/api/subscription';
import FailedDeleteInfoModal from './components/FailedDeleteInfoModal.vue';
import SuccessPasswordResetModal from './components/SuccessPasswordResetModal.vue';
import AdminCreateModal from './components/AdminCreateModal.vue';

const confirmDeletion = async () => {
  toggleDeleteInfoModal(false);
  toggleLoading(true);

  try {
    let response = await deleteSubscription();
    if (response.data.success) {
      const store = useSubscriberStore();
      store.reset();                           
      localStorage.removeItem('auth_token');   
      toggleLoading(false);
      toggleSuccessDeletionModal(true);


      setTimeout(() => {
        toggleSuccessDeletionModal(false);
        router.push('/login');
      }, 3000);

    } else {
      toggleLoading(false);
      console.error('Failed to delete subscription:', response);

      toggleFailedDeletionModal(true);
    }


  } catch (error) {
    toggleLoading(false);
    toggleFailedDeletionModal(true);
    console.error('Failed to delete subscription:', error);

  }
};


const showFailedDeleteInfoModal = ref(false);
const toggleFailedDeletionModal = (show) => {
  showFailedDeleteInfoModal.value = show;
  setTimeout(() => {
    showFailedDeleteInfoModal.value = !show;
  }, 3000);
}



const showSuccessDeleteInfoModal = ref(false);
const toggleSuccessDeletionModal = (show) => {
  showSuccessDeleteInfoModal.value = show;
}



const showLoadingModal = ref(false);

const toggleLoading = (show) => {
  showLoadingModal.value = show;
}

const showSuccessEdit = ref(false);

const toggleSuccessModal = () => {
  showSuccessEdit.value = true;
  setTimeout(() => {
    showSuccessEdit.value = false;
  }, 3000);
}


const showSuccessPasswordReset = ref(false);

const toggleSuccessPasswordResetModal = () => {
  showSuccessPasswordReset.value = true;
  setTimeout(() => {
    showSuccessPasswordReset.value = false;
  }, 3000);
}



const logout = () => {
  toggleLoading(true);
  setTimeout(() => {
    toggleLoading(false);
    router.push('/login');
  }, 2000);
}


const pagesWithSlateBackground = ref([]);


onMounted(() => {
  pagesWithSlateBackground.value = [
    'login', 'dashboard', 'admin', 'admin-edit',
    'adminDashboard',
    'forgotPassword',
    'recoverPassword',
    'adminsList',
    'adminsCreate'
  ];
});



const showAdminCreateModal = ref(false);
const toggleAdminCreateModal = (val) => {
  showAdminCreateModal.value = val;
}

</script>

<template>
  <div class="bg-white h-screen w-full flex flex-col justify-between relative">
    <Header @DeleteInfo="toggleDeleteInfoModal(true)" @LoggingOut="logout" />
    
    <AdminCreateModal v-if="showAdminCreateModal" @exit="toggleAdminCreateModal(false)"
       />
    
      <ConfirmDeleteInfoModal v-if="showDeleteInfoModal" @cancelDeletion="toggleDeleteInfoModal(false)"
      @confirmDeletion="confirmDeletion()" />
    <SuccessDeleteInfoModal v-if="showSuccessDeleteInfoModal" />
    <FailedDeleteInfoModal v-if="showFailedDeleteInfoModal" />



    <LoadingScreen v-if="showLoadingModal"></LoadingScreen>
    <SuccessEditInfoModal v-if="showSuccessEdit"></SuccessEditInfoModal>
    <SuccessPasswordResetModal v-if="showSuccessPasswordReset"></SuccessPasswordResetModal>
 
    <div :class="['flex-1 w-full pt-32', pagesWithSlateBackground.includes(route.name) ? 'bg-slate-50' : 'bg-white']">
      <div class="w-full lg:max-w-screen-2xl lg:mx-auto h-full  relative">
        <router-view @toggleLoadingOn="toggleLoading(true)" @toggleLoadingOff="toggleLoading(false)"
          @toggleSuccessModal="toggleSuccessModal()" @toggleSuccessResetModal="toggleSuccessPasswordResetModal()"
          @LoggingOut="logout" @createAdmin="toggleAdminCreateModal(true)" />
      </div>
    </div>

    <Footer />
  </div>
</template>
